/** Runtime mirror of the Prisma enum — browser-safe */
export const AccountType = {
    Revenue: 'Revenue',
    Expense: 'Expense',
    Asset: 'Asset',
    Liability: 'Liability',
    Equity: 'Equity',
};
const RevenueTypesByCategory = {
    Discounts: AccountType.Revenue,
    Donations: AccountType.Revenue,
    Products: AccountType.Revenue,
    // Refund method rides on Transaction.subAccount
    Refunds: AccountType.Revenue,
    ChargedTransactionFees: AccountType.Revenue,
    StoreCreditDiscounts: AccountType.Revenue,
    PayItForwardDiscounts: AccountType.Revenue,
    PayItForwardDonations: AccountType.Revenue,
    DiscountsFromMembership: AccountType.Revenue,
    PaymentPlanTax: AccountType.Revenue,
};
const ExpenseTypesByCategory = {
    /** @deprecated */
    TicketingFees: AccountType.Expense,
    PaidToSignupSoftware: AccountType.Expense,
    Advertising: AccountType.Expense,
    ConsumableSupplies: AccountType.Expense,
    CostOfGoodsSold: AccountType.Expense,
    Rent: AccountType.Expense,
    Food: AccountType.Expense,
    Insurance: AccountType.Expense,
    StripeFee: AccountType.Expense,
    /** @deprecated */
    StripePassoverFee: AccountType.Expense,
    Compensation: AccountType.Expense,
    Travel: AccountType.Expense,
    FirstPurchaseSignupSoftwareFee: AccountType.Expense,
    PaidForEventRegistration: AccountType.Expense,
    Accomodation: AccountType.Expense,
    PaidForDonations: AccountType.Expense,
    PaidForContests: AccountType.Expense,
    PaidForEmailMarketing: AccountType.Expense,
    PaidForMembership: AccountType.Expense,
    PaidForFestivalRegistration: AccountType.Expense,
    PaidForDirectDeposit: AccountType.Expense,
    StripeReconciliation: AccountType.Expense,
};
const LiablityTypesByCategory = {
    ExpectedExpenses: AccountType.Liability,
    OwedToSignupSoftware: AccountType.Liability,
    AccountsPayable: AccountType.Liability,
    DirectDepositPayable: AccountType.Liability,
    ExpectedInPersonPayment: AccountType.Liability,
    IncomeTaxesPayable: AccountType.Liability,
    OwnerInvestment: AccountType.Liability,
    RevenueRecievable: AccountType.Liability,
    UnusedStoreCredit: AccountType.Liability,
    StoreCredit: AccountType.Liability,
    UnusedPunchPassValue: AccountType.Liability,
    UnclaimedPayItForwardTicketValue: AccountType.Liability,
    OwedForEventRegistration: AccountType.Liability,
    OwedForDonations: AccountType.Liability,
    OwedForContests: AccountType.Liability,
    OwedForEmailMarketing: AccountType.Liability,
    OwedForMemberships: AccountType.Liability,
};
const EquityTypesByCategory = {
    OwnersDraw: AccountType.Equity,
};
const AssetTypesByCategory = {
    RevenueHeldBySignupSoftware: AccountType.Asset,
    InTransitToSignupSoftwareBank: AccountType.Asset,
    PayItForwardTicketValue: AccountType.Asset,
    PaymentPlanRevenueReceivable: AccountType.Asset,
    // Pre-received value; the cash promise is a Liability
    ExpectedPunchPassValuePayment: AccountType.Asset,
    ConnectedStripeAccount: AccountType.Asset,
    Equipment: AccountType.Asset,
    Inventory: AccountType.Asset,
    StripeAccount: AccountType.Asset,
    UnpaidCashPurchase: AccountType.Asset,
    AccountsReceivable: AccountType.Asset,
    AppreciatingAssets: AccountType.Asset,
    BankAccount: AccountType.Asset,
    SignupSoftwareBank: AccountType.Asset,
    PlatformStripeAccount: AccountType.Asset,
    InTransitToOrganizationBank: AccountType.Asset,
    CashOnHand: AccountType.Asset,
};
/**
 * The single source of truth mapping every AccountCategory to its
 * AccountType. The Record type errors if a category is missing.
 */
export const AccountCategoriesMap = {
    ...RevenueTypesByCategory,
    ...ExpenseTypesByCategory,
    ...LiablityTypesByCategory,
    ...EquityTypesByCategory,
    ...AssetTypesByCategory,
};
export const getAccountType = (category) => AccountCategoriesMap[category];
const profitLossSource = {
    ...RevenueTypesByCategory,
    ...ExpenseTypesByCategory,
};
export const ProfitLossKeys = Object.keys(profitLossSource).filter((key) => key in profitLossSource);
const balanceReportSource = {
    ...AssetTypesByCategory,
    ...LiablityTypesByCategory,
};
export const BalanceReportKeys = Object.keys(balanceReportSource).filter((key) => key in balanceReportSource);
export const COMPENSATION_METHODS = [
    'Cash',
    'StoreCredit',
    'DirectDeposit',
];
/** Expense accrues on the first, what is still owed sits on the second */
export const COMPENSATION_ACCRUAL_CATEGORIES = [
    'Compensation',
    'AccountsPayable',
];
/** Accounts whose subAccount carries the compensation method */
export const METHOD_TAGGED_CATEGORIES = [
    ...COMPENSATION_ACCRUAL_CATEGORIES,
    'DirectDepositPayable',
];
/** SubAccounts billable as PaidToSignupSoftware services */
export const APP_SERVICES = [
    'Membership',
    'EventRegistration',
    'Donations',
    'StaffManagement',
    'EmailMarketing',
    'Automations',
    'PrivateLessons',
    'Series',
    'Discounts',
    'Promotions',
    'Widgets',
    'Ecommerce',
    'FestivalRegistration',
    'ContestScoring',
    'QRCodes',
];
//# sourceMappingURL=account-categories.js.map